export function TopggRedirectPage ({props, match}){
  window.location.href = `https://top.gg/bot/606312049798152204/`
  return null
}